/**
 * Comparison Type Mappings
 * Maps between user-friendly comparison strings and API comparison type IDs
 */

export const COMPARISON_OPTIONS = [
  "Equals",
  "Contains",
  "Starts With",
  "Ends With",
] as const;

export type ComparisonOption = (typeof COMPARISON_OPTIONS)[number];

/**
 * Maps comparison type ID to user-friendly string
 */
export const comparisonIdToString = (id: number): string => {
  const mapping: Record<number, string> = {
    1: "Equals",
    2: "Contains",
    3: "Starts With",
    4: "Ends With",
  };
  return mapping[id] || `Type ${id}`;
};

/**
 * Maps user-friendly string to comparison type ID
 */
export const comparisonStringToId = (comparison: string): number => {
  const mapping: Record<string, number> = {
    Equals: 1,
    Contains: 2,
    "Starts With": 3,
    "Ends With": 4,
  };
  return mapping[comparison] || 0;
};
